// geekGuardrails.js - Comprehensive guardrails implementation

export const TOPICS = {
  COMICS: 'comics',
  ANIME: 'anime',
  MANGA: 'manga',
  GAMES: 'games',
  MOVIES: 'movies',
  TV: 'tv',
  CHARACTERS: 'characters',
  OTHER_GEEK: 'other_geek',
  NON_GEEK: 'non_geek'
};

// Comprehensive keywords dictionary organized by topic
const keywordDictionary = {
  [TOPICS.COMICS]: [
    'marvel', 'dc', 'comic', 'superhero', 'supervillain', 'avengers', 'justice league', 
    'x-men', 'spider-man', 'batman', 'superman', 'wonder woman', 'hulk', 'thor', 
    'iron man', 'captain america', 'flash', 'aquaman', 'green lantern', 'hawkeye',
    'black widow', 'daredevil', 'punisher', 'deadpool', 'wolverine', 'cyclops',
    'professor x', 'magneto', 'joker', 'harley quinn', 'catwoman', 'lex luthor',
    'thanos', 'galactus', 'darkseid', 'apocalypse', 'venom', 'carnage', 'spawn',
    'hellboy', 'image comics', 'dark horse', 'vertigo', 'watchmen', 'sandman',
    'stan lee', 'jack kirby', 'frank miller', 'alan moore', 'grant morrison',
    'todd mcfarlane', 'jim lee', 'issue', 'volume', 'annual', 'crossover event'
  ],
  [TOPICS.ANIME]: [
    'anime', 'japanese animation', 'otaku', 'studio ghibli', 'miyazaki', 
    'naruto', 'one piece', 'dragon ball', 'attack on titan', 'my hero academia', 
    'demon slayer', 'jujutsu kaisen', 'fullmetal alchemist', 'death note',
    'bleach', 'sailor moon', 'evangelion', 'gundam', 'cowboy bebop', 'akira',
    'ghost in the shell', 'pokemon anime', 'digimon', 'yugioh anime', 'hunter x hunter',
    'sword art online', 'one punch man', 'tokyo ghoul', 'fairy tail', 'haikyuu',
    'jojo bizarre adventure', 'naruto shippuden', 'boruto', 'gintama',
    'madoka magica', 'fate series', 'code geass', 'steins gate', 'your name',
    'weathering with you', 'spirited away', 'princess mononoke', 'howl moving castle',
    'shounen', 'shoujo', 'seinen', 'isekai', 'mecha', 'slice of life', 'shonen jump'
  ],
  [TOPICS.MANGA]: [
    'manga', 'japanese comic', 'mangaka', 'one piece manga', 'naruto manga', 
    'dragon ball manga', 'attack on titan manga', 'my hero academia manga',
    'demon slayer manga', 'jujutsu kaisen manga', 'shonen jump', 'weekly shonen',
    'tankobon', 'light novel', 'manhwa', 'manhua', 'webtoon', 'viz media',
    'kodansha', 'shueisha', 'berserk', 'vagabond', 'kingdom', 'vinland saga',
    'tokyo ghoul manga', 'death note manga', 'bleach manga', 'fullmetal alchemist manga',
    'hunter x hunter manga', 'jojo manga', 'chainsaw man', 'spy x family',
    'osamu tezuka', 'junji ito', 'naoki urasawa', 'eiichiro oda', 'masashi kishimoto',
    'hiromu arakawa', 'hajime isayama', 'kentaro miura'
  ],
  [TOPICS.GAMES]: [
    'rpg', 'jrpg', 'final fantasy', 'pokemon', 'zelda', 'mario', 'metroid',
    'dark souls', 'elden ring', 'persona', 'kingdom hearts', 'metal gear',
    'resident evil', 'silent hill', 'castlevania', 'mega man', 'sonic',
    'street fighter', 'mortal kombat', 'tekken', 'diablo', 'warcraft',
    'starcraft', 'overwatch', 'genshin impact', 'mmorpg', 'rpg maker',
    'visual novel', 'dating sim', 'dragon quest', 'chrono trigger', 'baldurs gate',
    'mass effect', 'bioware', 'square enix', 'capcom', 'konami', 'sega',
    'nintendo', 'playstation', 'xbox', 'steam', 'pc gaming'
  ],
  [TOPICS.MOVIES]: [
    'mcu', 'marvel cinematic', 'dceu', 'dc extended', 'avengers movie',
    'justice league movie', 'star wars', 'star trek', 'lord of the rings',
    'harry potter', 'hobbit', 'matrix', 'back to the future', 'terminator',
    'alien', 'predator', 'ghostbusters', 'indiana jones', 'jurassic park',
    'godzilla', 'king kong', 'pacific rim', 'blade runner', 'tron',
    'transformers', 'dune', 'avatar', 'disney', 'pixar', 'dreamworks',
    'studio ghibli film', 'anime movie', 'comic book movie', 'superhero movie',
    'sci-fi film', 'fantasy film', 'christopher nolan', 'peter jackson',
    'spielberg', 'james cameron', 'jj abrams', 'whedon', 'russo brothers'
  ],
  [TOPICS.TV]: [
    'tv show', 'television series', 'netflix series', 'hbo', 'disney+',
    'game of thrones', 'westworld', 'mandalorian', 'loki', 'wandavision',
    'stranger things', 'walking dead', 'star trek discovery', 'star trek picard',
    'doctor who', 'sherlock', 'supernatural', 'expanse', 'black mirror',
    'altered carbon', 'umbrella academy', 'witcher', 'wheel of time', 'rings of power',
    'house of the dragon', 'arcane', 'invincible', 'boys', 'peacemaker',
    'clone wars', 'avatar last airbender', 'legend of korra', 'animated series',
    'cartoon network', 'adult swim', 'toonami', 'nickelodeon', 'disney channel'
  ],
  [TOPICS.CHARACTERS]: [
    'character', 'protagonist', 'antagonist', 'villain', 'hero', 'antihero',
    'sidekick', 'origin story', 'backstory', 'power', 'ability', 'superpower',
    'transformation', 'alter ego', 'secret identity', 'costume', 'outfit', 'armor',
    'weapon', 'gadget', 'technology', 'species', 'race', 'alien', 'mutant',
    'meta-human', 'android', 'cyborg', 'robot', 'ai', 'vampire', 'werewolf',
    'zombie', 'god', 'deity', 'demon', 'angel', 'wizard', 'witch', 'sorcerer',
    'warrior', 'knight', 'samurai', 'ninja', 'pirate', 'bounty hunter'
  ],
  [TOPICS.OTHER_GEEK]: [
    'cosplay', 'convention', 'comic-con', 'fanfiction', 'fanart', 'fandom',
    'collectible', 'action figure', 'funko pop', 'merchandise', 'poster',
    'statue', 'replica', 'prop', 'memorabilia', 'limited edition', 'exclusive',
    'collector', 'mint condition', 'unboxing', 'review', 'ranking', 'tier list',
    'versus', 'battle', 'power level', 'theory', 'prediction', 'easter egg',
    'reference', 'cameo', 'post-credit', 'crossover', 'multiverse', 'timeline',
    'continuity', 'reboot', 'remake', 'sequel', 'prequel', 'spinoff', 'adaptation',
    'lore', 'worldbuilding', 'universe', 'canon', 'non-canon', 'retcon'
  ]
};

// Lists of common franchises/IPs by category
const franchisesByCategory = {
  comics: [
    'marvel', 'dc', 'image comics', 'dark horse', 'vertigo', 'wildstorm', 'valiant',
    'spawn', 'hellboy', 'walking dead comic', 'saga', 'watchmen', 'sandman', 'preacher',
    'boys comic', 'invincible comic', 'kick-ass', 'sin city', '300', 'v for vendetta',
    'league of extraordinary gentlemen', 'scott pilgrim', 'umbrella academy comic'
  ],
  anime_manga: [
    'dragon ball', 'naruto', 'one piece', 'bleach', 'attack on titan', 'my hero academia',
    'demon slayer', 'jujutsu kaisen', 'tokyo ghoul', 'death note', 'fullmetal alchemist',
    'hunter x hunter', 'jojo bizarre adventure', 'sword art online', 'evangelion',
    'cowboy bebop', 'sailor moon', 'one punch man', 'fairy tail', 'pokemon',
    'digimon', 'yugioh', 'studio ghibli', 'ghost in the shell', 'akira'
  ],
  sci_fi_fantasy: [
    'star wars', 'star trek', 'lord of the rings', 'harry potter', 'game of thrones',
    'wheel of time', 'dune', 'foundation', 'expanse', 'hitchhiker guide',
    'doctor who', 'firefly', 'battlestar galactica', 'stargate', 'alien', 'predator',
    'terminator', 'matrix', 'blade runner', 'back to the future', 'jurassic park',
    'planet of the apes', 'transformers', 'power rangers', 'tron'
  ],
  gaming: [
    'final fantasy', 'pokemon game', 'legend of zelda', 'mario', 'sonic',
    'metroid', 'halo', 'mass effect', 'dragon age', 'elder scrolls', 'fallout',
    'witcher', 'dark souls', 'bloodborne', 'elden ring', 'monster hunter',
    'metal gear', 'resident evil', 'silent hill', 'kingdom hearts', 'persona'
  ]
};

// Combine franchise lists into one large array
const allFranchises = Object.values(franchisesByCategory).flat();

// First-level check: Basic keyword matching
export function isGeekCultureRelatedBasic(query) {
  const normalizedQuery = query.toLowerCase();
  
  // Check for all topics except NON_GEEK
  const allGeekKeywords = Object.entries(keywordDictionary)
    .filter(([topic]) => topic !== TOPICS.NON_GEEK)
    .flatMap(([_, keywords]) => keywords);
  
  // Check if any geek keyword is in the query
  return allGeekKeywords.some(keyword => 
    normalizedQuery.includes(keyword) || 
    // Also check for possessive forms and plurals
    normalizedQuery.includes(keyword + "'s") ||
    normalizedQuery.includes(keyword + "s")
  );
}

// Second-level check: Check against specific franchises
export function matchesFranchise(query) {
  const normalizedQuery = query.toLowerCase();
  return allFranchises.some(franchise => normalizedQuery.includes(franchise));
}

// Third-level check: Advanced pattern detection
export function hasGeekPattern(query) {
  const normalizedQuery = query.toLowerCase();
  
  // Check for comparison patterns (common in geek discussions)
  if (/who (would win|is stronger|is better|is faster)/.test(normalizedQuery)) {
    return true;
  }
  
  // Check for "tell me about" pattern
  if (/tell me about|explain|what is|who is|how does/.test(normalizedQuery)) {
    // This is ambiguous, so only return true if we also find franchise names
    return matchesFranchise(query);
  }
  
  // Check for origin/power patterns
  if (/origin|power|ability|superpower|weakness|story|history|background|created by/.test(normalizedQuery)) {
    return true;
  }
  
  // Check for recommendation patterns
  if (/best|recommend|top|favorite|similar to|like|worth|should i read|should i watch/.test(normalizedQuery)) {
    // Only if combined with media types
    return /manga|comic|anime|movie|show|series|game|character/.test(normalizedQuery);
  }
  
  return false;
}

// Fourth-level check: Identify non-geek topics
export function containsNonGeekTopic(query) {
  const normalizedQuery = query.toLowerCase();
  
  // Define non-geek topic indicators
  const nonGeekTopics = [
    // Politics
    'president', 'political', 'election', 'democrat', 'republican', 'congress', 'senate',
    'government', 'policy', 'politician', 'vote', 'ballot', 'campaign', 'administration',
    
    // Finance/Business
    'stock market', 'invest', 'bitcoin', 'cryptocurrency', 'finance', 'mortgage', 'loan',
    'banking', 'tax', 'irs', 'budget', 'accounting', 'business plan', 'startup',
    'entrepreneur', 'market analysis', 'financial advice', 'recession', 'inflation',
    
    // Personal advice
    'relationship advice', 'breakup', 'marriage', 'divorce', 'dating advice', 'proposal',
    'wedding', 'boyfriend', 'girlfriend', 'spouse', 'date ideas', 'tinder', 'bumble',
    'dating app',
    
    // Health
    'medical advice', 'health condition', 'symptom', 'diagnosis', 'treatment', 'medication',
    'doctor', 'hospital', 'disease', 'illness', 'injury', 'surgery', 'prescription',
    'diet plan', 'weight loss', 'exercise routine', 'workout plan', 'nutrition advice',
    
    // Academic/Professional
    'homework help', 'assignment', 'thesis', 'dissertation', 'research paper',
    'job application', 'resume', 'cover letter', 'interview preparation', 'career advice',
    
    // Legal
    'legal advice', 'lawsuit', 'sue', 'attorney', 'lawyer', 'court case', 'legal document',
    'contract review', 'terms of service', 'privacy policy', 'copyright issue',
    
    // News/Current Events
    'current news', 'breaking news', 'recent event', 'latest development',
    'this morning', 'yesterday', 'last week', 'this month', 'this year',
    
    // Others
    'weather forecast', 'traffic update', 'recipe', 'cooking instruction', 'travel advice',
    'vacation planning', 'hotel recommendation', 'flight booking', 'car rental'
  ];
  
  return nonGeekTopics.some(topic => normalizedQuery.includes(topic));
}

// Fifth-level check: Explicit blacklist of common non-geek queries
export function isBlacklistedQuery(query) {
  const normalizedQuery = query.toLowerCase();
  
  // Array of common non-geek questions
  const blacklistedQueries = [
    'who is the president',
    'what time is it',
    'what is the weather',
    'how old are you',
    'who are you',
    'what can you do',
    'tell me a joke',
    'what is your name',
    'what year is it',
    'what day is it',
    'who won the super bowl',
    'who won the world cup',
    'who won the election',
    'what is the stock market doing',
    'what is the price of bitcoin',
    'what should i invest in',
    'how do i make money',
    'help me with my homework',
    'write me an essay',
    'help me with my assignment',
    'what is the meaning of life',
    'what is the capital of',
    'translate this to',
    'how do i cook',
    'what is the recipe for',
    'how do i fix my',
    'what is the best way to clean',
    'how do i get to',
    'directions to'
  ];
  
  return blacklistedQueries.some(blacklisted => normalizedQuery.includes(blacklisted));
}

// Main function: Comprehensive geek culture relevance check
export function isGeekCultureQuery(query) {
  // Start with blacklist check (fastest rejection)
  if (isBlacklistedQuery(query)) {
    return false;
  }
  
  // Then check for explicit non-geek topics
  if (containsNonGeekTopic(query)) {
    // If it contains a non-geek topic but ALSO contains a strong geek indicator,
    // it might still be geek-related (e.g., "Who would win in a presidential election: Captain America or Superman?")
    if (matchesFranchise(query)) {
      return true;
    }
    return false;
  }
  
  // Now run positive checks in order of confidence
  if (matchesFranchise(query)) {
    return true;
  }
  
  if (isGeekCultureRelatedBasic(query)) {
    return true;
  }
  
  if (hasGeekPattern(query)) {
    return true;
  }
  
  // Default to false - be conservative about what we consider geek culture
  return false;
}

// Function to determine which geek topic(s) the query belongs to
export function categorizeGeekQuery(query) {
  const normalizedQuery = query.toLowerCase();
  const matchedTopics = [];
  
  // Check each topic
  for (const [topic, keywords] of Object.entries(keywordDictionary)) {
    // Skip non-geek topic
    if (topic === TOPICS.NON_GEEK) continue;
    
    // Check if any keyword from this topic appears in the query
    const hasMatch = keywords.some(keyword => 
      normalizedQuery.includes(keyword) || 
      normalizedQuery.includes(keyword + "'s") ||
      normalizedQuery.includes(keyword + "s")
    );
    
    if (hasMatch) {
      matchedTopics.push(topic);
    }
  }
  
  return matchedTopics.length > 0 ? matchedTopics : [TOPICS.OTHER_GEEK];
}

// Function to generate a friendly redirection message
export function generateRedirectMessage(query) {
  const messages = [
    "I'm specialized in geek culture topics like comics, anime, manga, and related franchises. I'd be happy to answer questions about superheroes, anime characters, comic book storylines, or similar topics instead!",
    
    "As your geek culture AI assistant, I focus exclusively on comics, anime, manga, and related topics. I don't have information about that, but I'd love to discuss Marvel, DC, popular anime series, or other geek culture topics with you!",
    
    "I'm designed specifically for geek culture questions about comics, anime, manga, and related media. While I can't answer that question, I'd be thrilled to talk about superheroes, anime characters, or your favorite sci-fi franchises!",
    
    "That's outside my area of expertise. I'm your geek culture specialist, focused on comics, anime, manga, and similar topics. I'd be happy to discuss Batman, Naruto, the Marvel Cinematic Universe, or other geeky subjects instead!"
  ];
  
  // Return a random message from the array
  return messages[Math.floor(Math.random() * messages.length)];
}

// Enhanced redirection with suggestions
export function getRedirectWithSuggestions(query) {
  const baseMessage = generateRedirectMessage(query);
  
  const suggestions = [
    "Who would win in a fight between Superman and Goku?",
    "Explain the Marvel multiverse and its different Earth designations.",
    "What are the best manga series for beginners?",
    "How did Batman become a superhero?",
    "What are the different types of Kryptonite and how do they affect Superman?",
    "Who are the strongest characters in the My Hero Academia universe?",
    "What is the reading order for Invincible comics?",
    "Explain the different iterations of Spider-Man in comics, movies, and TV.",
    "What are the most powerful artifacts in the Marvel universe?"
  ];
  
  // Get 3 random suggestions
  const randomSuggestions = [];
  while (randomSuggestions.length < 3 && suggestions.length > 0) {
    const index = Math.floor(Math.random() * suggestions.length);
    randomSuggestions.push(suggestions[index]);
    suggestions.splice(index, 1);
  }
  
  return {
    message: baseMessage,
    suggestions: randomSuggestions
  };
} 